'use strict';

DoohApps.filter('licenseFilter', function () {
    return function (value, hideDefault, putInBrackets) {

        function PutInBrackets(value) {
            var put = putInBrackets == true;
            return (put ? '(' : '') + value + (put ? ')' : '');
        }

        switch (parseInt(value)) {            
            case 1:
                return PutInBrackets('Partner');
            case 2:
                return PutInBrackets('Preview');
            case 0:
            default: 
                return typeof hideDefault == 'undefined' || hideDefault ? '' : 'Commercial';            
        }       
    }
});